import type { FileBaseUsage } from '@vedalib/editor/lib/files'
import { FileUsageSource } from '@vedalib/editor/lib/files'

export const getUrlMedia = (
  media: Omit<FileBaseUsage, 'type'> | null,
  filePath?: string,
  linkWrapper?: (link: string) => string,
) => {
  if (media?.source === FileUsageSource.url) {
    return linkWrapper ? linkWrapper(media?.url || '') : media?.url
  } else {
    return filePath
  }
}
